import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "antd";
import { useQuery, useQueryClient } from "react-query";
import Select from "react-select";
import { toast } from "react-toastify";

import _ from "../../../i18n";
import Button from "../../common/Button";
import Loader from "../../common/Loader";
import { SELECT_STYLES } from "../../../config";
import { archiveUser, archiveGoPeopleContact } from "../../../api";
import styles from "./UserArchiveModal.module.scss";
import IconInfo from "../../common/icons/IconInfo";

const archiveOptions = [
  { label: "Retraite", value: "RETIREMENT" },
  { label: "Maladie", value: "DISEASE" },
  { label: "Décés", value: "DEATH" },
  { label: "Autre", value: "OTHER" },
];

const UserArchiveModal = ({
  modalOpen,
  closeModal,
  currentArchiveMember,
  onAfterSave,
}) => {
  const auth = useSelector((state) => state.auth);
  const { token, goPeopleCommunityId } = auth;
  const fiduciary = useSelector((state) => state.folder.fiduciary);

  const [archiveType, setArchiveType] = useState(archiveOptions[0]);
  const [archiveDesc, setArchiveDesc] = useState("");
  const [isArchiving, setIsArchiving] = useState(false);

  const handleArchiveMember = async () => {
    setIsArchiving(true);
    const reason = archiveType.value;

    try {
      await archiveUser(token, currentArchiveMember.ttp_user_id, reason, archiveDesc);

      if (currentArchiveMember.uuid && goPeopleCommunityId) {
        await archiveGoPeopleContact(goPeopleCommunityId, currentArchiveMember.uuid, reason, archiveDesc);
      }

      setIsArchiving(false);
      setArchiveDesc("");
      onAfterSave();
      toast.success("Contact archivé avec succès");
    } catch (e) {
      setIsArchiving(false);
      toast.error(_("error_try_again"));
    }
  };

  return (
    <>
      <Modal
        width="50vw"
        height="40vh"
        closable={false}
        open={modalOpen}
        footer={null}
        onCancel={(e) => {
          e.stopPropagation();
          closeModal();
        }}
        maskClosable={true}
        destroyOnClose={true}
      >
        <div className={styles.modal_header}>
          Confirmation pour:{" "}
          {`${currentArchiveMember.last_name ? currentArchiveMember.last_name : ""} ${
            currentArchiveMember.first_name
              ? currentArchiveMember.first_name
              : ""
          }`}
        </div>
        <div
          className={styles.modal_close}
          onClick={() => {
            closeModal();
          }}
        >
          <i className="icon-ttp-close"></i>
        </div>
        <div className={styles.modal_content}>
          <h3>Voulez vous archiver ce contact ?</h3>

          <div className="grid-x">
            <div className="cell small-12 medium-6">
              <label className="ttp-label">Motif</label>
              <Select
                styles={SELECT_STYLES}
                options={archiveOptions}
                isSearchable={false}
                value={archiveType}
                onChange={(e) => setArchiveType(e)}
                // selectStyles={selectStyles}
                classNamePrefix="react-select"
              />
            </div>
          </div>

          <div>
            <label className="ttp-label">{_(`description`)}</label>
            <textarea
              rows="4"
              className="ttp-input"
              value={archiveDesc}
              onChange={(e) => setArchiveDesc(e.target.value)}
            />
            {/* <span className={styles.error}>{errors.descriptionFr}</span> */}
          </div>

          <div className={styles.archive_actions}>
            <Button variant="default" onClick={closeModal}>
              {_("no")}
            </Button>

            {isArchiving ? (
              <Button
                variant="primary"
                style={{
                  paddingTop: "15px",
                  paddingBottom: "15px",
                  width: "200px",
                  justifyContent: "center",
                }}
              >
                <Loader
                  style={{
                    height: "10px",
                  }}
                  color={"#fff"}
                />
              </Button>
            ) : (
              <Button
                disabled={archiveDesc.length < 3}
                onClick={handleArchiveMember}
                style={{ width: "200px", justifyContent: "center" }}
              >
                {_("yes")}
              </Button>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UserArchiveModal;
